<template>
  <!--page-->
  <div class="p4_bgpage p4_spage">
    <!---s-bt-audio-->
    <div class="p4_buttonaudio">
      <!-- <my-audio></my-audio> -->
    </div>
    <!---s-s-SLOGAN-大-->
    <div class="p4_sliceSLOGANda"><img class="p4_diSLOGANda" src="../../assets/p4/images/imgSLOGAN-da.png"
        referrerpolicy="no-referrer" /></div>
    <!--exchange-->
    <div class="p4_bgexchange p4_sexchange">
      <!---s-bt-exhangedbt-->
      <div class="p4_buttonexhangedbt" v-if="exchangeStatus == 2"><img class="p4_diexhangedbt"
          src="../../assets/p4/images/imgexhangedbt.png" referrerpolicy="no-referrer" /></div>
      <!---s-bt-exchangebt-->
      <div class="p4_buttonexchangebt" v-if="exchangeStatus == 1"><img class="p4_diexchangebt" @click="exchange"
          src="../../assets/p4/images/imgexchangebt.png" referrerpolicy="no-referrer" /></div>
      <!---s-bt-exchangebtgay-->
      <div class="p4_buttonexchangebtg" v-if="exchangeStatus == 0"><img class="p4_diexchangebtgay"
          src="../../assets/p4/images/imgexchangebtgay.png" referrerpolicy="no-referrer" /></div>
    </div>
    <!--lotterymain-->
    <div class="p4_slotterymain">
      <!---s-s-slogon2-->
      <div class="p4_sliceslogon2"><img class="p4_dislogon2" src="../../assets/p4/images/imgslogon2.png"
          referrerpolicy="no-referrer" /></div>
      <!--reward-->
      <div class="p4_bgreward p4_sreward">
        <!---s-bt-rewardbtactive-->
        <div class="p4_buttonrewardbtact" v-if="leftLotteryNum > 0"><img class="p4_direwardbtactive" @click="lottery"
            src="../../assets/p4/images/imgrewardbtactive.png" referrerpolicy="no-referrer" /></div>
        <!---s-bt-rewardbtinactive-->
        <div class="p4_buttonrewardbtina" v-else><img class="p4_direwardbtinactiv"
            src="../../assets/p4/images/imgrewardbtinactive.png" referrerpolicy="no-referrer" /></div>
        <!--rewardeffect-->
        <div class="p4_srewardeffect">
          <!---s-s-e6-->
          <div class="p4_slicee6"><img class="p4_die6" src="../../assets/p4/images/imge6.png" referrerpolicy="no-referrer"
              v-show="lotterySel == 6" /></div>
          <!---s-s-e1-->
          <div class="p4_slicee1"><img class="p4_die1" src="../../assets/p4/images/imge1.png" referrerpolicy="no-referrer"
              v-show="lotterySel == 1" /></div>
          <!---s-s-e5-->
          <div class="p4_slicee5"><img class="p4_die5" src="../../assets/p4/images/imge5.png" referrerpolicy="no-referrer"
              v-show="lotterySel == 5" /></div>
          <!---s-s-e2-->
          <div class="p4_slicee2"><img class="p4_die2" src="../../assets/p4/images/imge2.png" referrerpolicy="no-referrer"
              v-show="lotterySel == 2" /></div>
          <!---s-s-e4-->
          <div class="p4_slicee4"><img class="p4_die4" src="../../assets/p4/images/imge4.png" referrerpolicy="no-referrer"
              v-show="lotterySel == 4" /></div>
          <!---s-s-e3-->
          <div class="p4_slicee3"><img class="p4_die3" src="../../assets/p4/images/imge3.png" referrerpolicy="no-referrer"
              v-show="lotterySel == 3" /></div>
        </div>
      </div>
      <!---s-tx-sendcards-->
      <div class="p4_textsendcards">当前已送出插画：{{ sendCardNum }}</div>
      <!--addrs-->
      <div class="p4_saddrs flex-row">
        <!--addr-->
        <div class="p4_saddr">
          <!---s-bt-editaddrbt-->
          <div class="p4_buttoneditaddrbt" v-if="hasAddr"><img class="p4_dieditaddrbt" @click="editAddr"
              src="../../assets/p4/images/imgeditaddrbt.png" referrerpolicy="no-referrer" /></div>
          <!---s-bt-addrbt-->
          <div class="p4_buttonaddrbt" v-else-if="myReward == 1 || myReward == 2 || myReward == 3 || myReward == 5"><img
              class="p4_diaddrbt" @click="editAddr" src="../../assets/p4/images/imgaddrbt.png"
              referrerpolicy="no-referrer" /></div>
          <!---s-bt-addrbtgray-->
          <div class="p4_buttonaddrbtgray" v-else><img class="p4_diaddrbtgray"
              src="../../assets/p4/images/imgaddrbtgray.png" referrerpolicy="no-referrer" /></div>
        </div>
        <!---s-bt-sendcardbt-->
        <div class="p4_buttonsendcardbt"><img class="p4_disendcardbt" @click="sendCard"
            src="../../assets/p4/images/imgsendcardbt.png" referrerpolicy="no-referrer" /></div>
      </div>
    </div>
    <!--bar-->
    <bar :value="4"></bar>
    <!---s-dg-editaddrdg-->
    <van-popup class="p4_bgeditaddrdg p4_dialogeditaddrdg" :close-on-click-overlay="false" v-bind:value="popeditaddrdg">
      <!---s-bt-X-->
      <div class="p4_buttonX"><img class="p4_diX" src="../../assets/p4/images/imgX.png" @click="popeditaddrdg = false"
          referrerpolicy="no-referrer" /></div>
      <!---s-tx-editaddrtitle-->
      <div class="p4_texteditaddrtitle">{{ addrTitle }}</div>
      <!--name-->
      <div class="p4_bgname p4_sname">
        <!---s-in-namein-->
        <div class="p4_inputnamein">
          <van-field v-model="innamein" maxlength="8" placeholder="">
          </van-field>
        </div>
      </div>
      <!--mobile-->
      <div class="p4_bgmobile p4_smobile">
        <!---s-in-mobiliein-->
        <div class="p4_inputmobiliein">
          <van-field v-model="inmobiliein" type="digit" maxlength="11" placeholder="">
          </van-field>
        </div>
      </div>
      <!--addrdetail-->
      <div class="p4_bgaddrdetail p4_saddrdetail">
        <!---s-in-addrdetailin-->
        <div class="p4_inputaddrdetailin">
          <van-field v-model="inaddrdetailin" maxlength="100" type="textarea">
          </van-field>
        </div>
      </div>
      <!---s-bt-editbt-->
      <div class="p4_buttoneditbt"><img class="p4_dieditbt" @click="saveAddr" src="../../assets/p4/images/imgeditbt.png"
          referrerpolicy="no-referrer" /></div>
    </van-popup>
    <!---s-dg-exchngeconfirm-->
    <van-popup class="p4_bgexchngeconfirm p4_dialogexchngeconfirm" :close-on-click-overlay="false"
      v-bind:value="popexchngeconfirm">
      <!--exconfreward-->
      <div class="p4_bgexconfreward p4_sexconfreward">
        <!---s-s-exconrew-->
        <div class="p4_sliceexconrew"><img class="p4_diexconrew" src="../../assets/p4/images/imgexconrew.png"
            referrerpolicy="no-referrer" /></div>
      </div>
      <!---s-bt-X5-->
      <div class="p4_buttonX5"><img class="p4_diX5" src="../../assets/p4/images/imgX5.png"
          @click="popexchngeconfirm = false" referrerpolicy="no-referrer" /></div>
      <!---s-tx-exconname-->
      <div class="p4_textexconname">钻石*300</div>
      <!---s-tx-excontips-->
      <div class="p4_textexcontips">是否使用<span>16张回忆插画</span>兑换奖励</div>
      <!---s-bt-concancelbt-->
      <div class="p4_buttonconcancelbt"><img class="p4_diconcancelbt" @click="popexchngeconfirm = false"
          src="../../assets/p4/images/imgconcancelbt.png" referrerpolicy="no-referrer" />
      </div>
      <!---s-bt-consurebt-->
      <div class="p4_buttonconsurebt"><img class="p4_diconsurebt" @click="doExchange"
          src="../../assets/p4/images/imgconsurebt.png" referrerpolicy="no-referrer" />
      </div>
    </van-popup>
    <!---s-dg-exchangesuccvir-->
    <van-popup class="p4_bgexchangesuccvir p4_dialogexchangesuccvi" :close-on-click-overlay="false"
      v-bind:value="popexchangesuccvir">
      <!---s-bt-X4-->
      <div class="p4_buttonX4"><img class="p4_diX4" src="../../assets/p4/images/imgX4.png"
          @click="popexchangesuccvir = false" referrerpolicy="no-referrer" /></div>
      <!--exvirreward-->
      <div class="p4_bgexvirreward p4_sexvirreward">
        <!---s-s-exvirrew-->
        <div class="p4_sliceexvirrew"><img class="p4_diexvirrew" src="../../assets/p4/images/imgexvirrew.png"
            referrerpolicy="no-referrer" /></div>
      </div>
      <!---s-tx-exvirname-->
      <div class="p4_textexvirname">兑换成功！</div>
      <!---s-tx-exvirtips-->
      <div class="p4_textexvirtips">奖励邮件稍后将会发送至绑定账号，
        请注意查收~
      </div>
      <!---s-bt-surebt4-->
      <div class="p4_buttonsurebt4"><img class="p4_disurebt4" @click="popexchangesuccvir = false"
          src="../../assets/p4/images/imgsurebt4.png" referrerpolicy="no-referrer" />
      </div>
    </van-popup>
    <!---s-dg-lotteryentdg-->
    <van-popup class="p4_bglotteryentdg p4_dialoglotteryentd" :close-on-click-overlay="false"
      v-bind:value="poplotteryentdg">
      <!---s-bt-X3-->
      <div class="p4_buttonX3"><img class="p4_diX3" src="../../assets/p4/images/imgX3.png"
          @click="poplotteryentdg = false" referrerpolicy="no-referrer" /></div>
      <!---s-tx-恭喜获得-->
      <div class="p4_textgongxhd">恭喜获得</div>
      <!--entreward-->
      <div class="p4_bgentreward p4_sentreward">
        <!---s-s-entrew1-->
        <div class="p4_sliceentrew1" v-if="myReward == 1"><img class="p4_dientrew1"
            src="../../assets/p4/images/imgentrew1.png" referrerpolicy="no-referrer" /></div>
        <!---s-s-entrew3-->
        <div class="p4_sliceentrew3" v-if="myReward == 2"><img class="p4_dientrew3"
            src="../../assets/p4/images/imgentrew3.png" referrerpolicy="no-referrer" /></div>
        <!---s-s-entrew2-->
        <div class="p4_sliceentrew2" v-if="myReward == 3"><img class="p4_dientrew2"
            src="../../assets/p4/images/imgentrew2.png" referrerpolicy="no-referrer" /></div>
        <!---s-s-entrew4-->
        <div class="p4_sliceentrew4" v-if="myReward == 5"><img class="p4_dientrew4"
            src="../../assets/p4/images/imgentrew4.png" referrerpolicy="no-referrer" /></div>
      </div>
      <!---s-tx-entrewtname-->
      <div class="p4_textentrewtname">{{ relRewardName }}</div>
      <!---s-tx-entrewtips-->
      <div class="p4_textentrewtips">欧气爆发！快去填写收货地址吧~</div>
      <!---s-bt-editaddrbtdg-->
      <div class="p4_buttoneditaddrbtd"><img class="p4_dieditaddrbtdg" @click="editAddr"
          src="../../assets/p4/images/imgeditaddrbtdg.png" referrerpolicy="no-referrer" /></div>
    </van-popup>
    <!---s-dg-lotteryvirdg-->
    <van-popup class="p4_bglotteryvirdg p4_dialoglotteryvirdg" :close-on-click-overlay="false"
      v-bind:value="poplotteryvirdg">
      <!---s-bt-X2-->
      <div class="p4_buttonX2"><img class="p4_diX2" src="../../assets/p4/images/imgX2.png"
          @click="poplotteryvirdg = false" referrerpolicy="no-referrer" /></div>
      <!---s-tx-virtitl-->
      <div class="p4_textvirtitl">恭喜获得</div>
      <!--virreward-->
      <div class="p4_bgvirreward p4_svirreward">
        <!---s-s-diamond-->
        <div class="p4_slicediamond" v-if="myReward == 6"><img class="p4_didiamond"
            src="../../assets/p4/images/imgdiamond.png" referrerpolicy="no-referrer" /></div>
        <!---s-s-stone-->
        <div class="p4_slicestone" v-if="myReward == 4"><img class="p4_distone" src="../../assets/p4/images/imgstone.png"
            referrerpolicy="no-referrer" /></div>
      </div>
      <!---s-tx-virrewardname-->
      <div class="p4_textvirrewardname">{{ virRewardName }}</div>
      <!---s-tx-virtip-->
      <div class="p4_textvirtip">奖励邮件稍后将会发送至绑定账号，
        请注意查收~
      </div>
      <!---s-bt-virsurebt-->
      <div class="p4_buttonvirsurebt"><img class="p4_divirsurebt" @click="poplotteryvirdg = false"
          src="../../assets/p4/images/imgvirsurebt.png" referrerpolicy="no-referrer" />
      </div>
    </van-popup>
    <!---s-dg-addrsucc-->
    <van-popup class="p4_bgaddrsucc p4_dialogaddrsucc" :close-on-click-overlay="false" v-bind:value="popaddrsucc">
      <!---s-bt-X1-->
      <div class="p4_buttonX1"><img class="p4_diX1" src="../../assets/p4/images/imgX1.png" @click="popaddrsucc = false"
          referrerpolicy="no-referrer" /></div>
      <!---s-tx-addrsucctitle-->
      <div class="p4_textaddrsucctitle">提交成功！</div>
      <!---s-tx-addrsucccontent-->
      <div class="p4_textaddrsuccconte">实物奖励会在活动结束后30个
        工作日内寄出，请注意查收~
      </div>
      <!---s-bt-sure1-->
      <div class="p4_buttonsure1"><img class="p4_disure1" src="../../assets/p4/images/imgsure1.png"
          @click="popaddrsucc = false" referrerpolicy="no-referrer" /></div>
    </van-popup>
    <login-bind ref="loginBind"></login-bind>
    <common-alert ref="alert"></common-alert>
    <show-err ref="errObj"></show-err>
  </div>
</template>

<style lang="css" scoped>
@import '../../assets/p4/css/s4.css';
</style>

<script>
import Vue from 'vue';
import { Popup, Field } from 'vant';
import LoginBind from "@/components/loginbind";
import ShowErr from "@/components/showerr";
import CommonAlert from "@/components/commonalert";
import Bar from "@/components/bar"
import info from "@/api/states/info";
import { timeLessFillAddress, timeLessGetAward, timeLessGetLotteryAward } from "@/api/apis";
// import MyAudio from "@/components/audio";

Vue.use(Popup, Field);

export default {
  name: 'Reward',
  components: { ShowErr, LoginBind, Bar, CommonAlert },
  data() {
    return {
      popeditaddrdg: false,
      innamein: '',
      inmobiliein: '',
      inaddrdetailin: '',
      popexchngeconfirm: false,
      popexchangesuccvir: false,
      poplotteryentdg: false,
      poplotteryvirdg: false,
      popaddrsucc: false,
      exchangeStatus: 0, // 0-不能兑换 1-可以兑换 2-已兑换
      leftLotteryNum: 0,
      sendCardNum: 0,
      lotterySel: 0,
      addrTitle: "我的地址",
      hasAddr: false,
      rewardMap: { // 1-6分别是6种奖励,100钻石，魔神石自选包,画册，魂卡，挂画，新周边
        1: 6,
        2: 4,
        3: 5,
        4: 3,
        5: 2,
        6: 1,
      },
      rewards: {
        1: {
          name: "咕勇者眼罩*1",
        },
        2: {
          name: "睡衣魔女挂画*1",
        },
        3: {
          name: "纪念魂卡套装*1",
        },
        4: {
          "name": "魔神石自选包*1",
        },
        5: {
          "name": "《勇者之约》纪念画册*1",
        },
        6: {
          "name": "钻石*100",
        },
      },
      virRewardName: "",
      relRewardName: "",
      myReward: 0,
      errObj: null,
      loginBind: null,
      alertObj: null,
    };
  },

  mounted() {
    info.getTime()

    document.getElementsByClassName("p4_buttonaudio")[0].appendChild(this.$myAudio.$el);

    this.errObj = this.$refs["errObj"]
    this.loginBind = this.$refs["loginBind"]
    this.alertObj = this.$refs["alert"]

    this.checkBind()
  },
  methods: {
    async checkBind(showDialog = false) {
      try {
        let loginStatus = await this.loginBind.check(showDialog)
        const infoStatus = await info.getInfo()
        if (infoStatus) {
          this.getTimeLessInfo()
        }
        return loginStatus

      } catch (error) {
        if (showDialog) {
          this.errObj.showErr(error)
        }
        console.log(error)
      }

      return false
    },
    getTimeLessInfo() {
          this.hasAddr = info.isAddress
          this.sendCardNum = info.sendTimes

          if (this.hasAddr && info.addr) {
            this.inmobiliein = info.addr.phone
            this.innamein = info.addr.name
            this.inaddrdetailin = info.addr.address
          }

          // TODO 当前地址要接口返回，否则无法修改的时候显示

          // left lottery num
          // TODO test
          // this.sendCardNum = 5
          // res.lotteryAwardStatus = 0
          // res.lotteryAward = 0
          if (info.lotteryAwardStatus == 0 && this.sendCardNum >= 5) {
            this.leftLotteryNum = 1
          } else {
            this.leftLotteryNum = 0
          }
          if (info.lotteryAwardStatus == 1 && info.lotteryAward > 0) {
            this.myReward = this.rewardMap[info.lotteryAward]
            this.lotterySel = this.myReward
          }

          // exchange status
          // TODO test
          // res.cardInfo = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]
          this.exchangeStatus = 0
          if (info.awardStatus == 1) {
            this.exchangeStatus = 2
          } else {
            // check cards
            let hasAllCards = true
            for (let i = 0; i < info.cardInfo.length; i++) {
              if (info.cardInfo[i] == 0) {
                hasAllCards = false
                break
              }
            }
            if (hasAllCards) {
              this.exchangeStatus = 1
            }
          }
    },
    exchange() {
      // check 活动结束
      if (!this.alertObj.checkEnd()) {
        return
      }
      this.popexchngeconfirm = true;
    },
    doExchange() {
      // check 活动结束
      if (!this.alertObj.checkEnd()) {
        return
      }
      // request
      timeLessGetAward().then(res => {
        // TODO test
        // res.code = 0
        if (res.code !== 0) {
          this.errObj.showErr(res.message)
        } else {
          this.exchangeStatus = 2
          this.popexchangesuccvir = true;
          this.popexchngeconfirm = false;

          info.getInfo(true)
        }
      }).catch(err => {
        this.errObj.showErr(err)
        throw err
      })
    },
    lottery() {
      if (this.leftLotteryNum <= 0) {
        return;
      }

      // check 活动结束
      if (!this.alertObj.checkEnd()) {
        return
      }
      
      // request
      timeLessGetLotteryAward().then(res => {
        // TODO test
        // res.code = 0
        // res.data = 5
        if (res.code !== 0) {
          this.errObj.showErr(res.message)
        } else {
          let reward = res.data
          this.myReward = this.rewardMap[reward]
          let type = 2
          if (reward == 1 || reward == 2) {
            type = 1
            this.virRewardName = this.rewards[this.myReward].name
          } else {
            this.relRewardName = this.rewards[this.myReward].name
          }
          this.leftLotteryNum--
          info.getInfo(true)
          this.doLottery(5, this.myReward, type);
        }
      }).catch(err => {
        this.errObj.showErr(err)
        throw err
      })
    },
    doLottery(interval, target, type) { // type 1-虚拟物品 2-实物
      this.lotterySel = this.lotterySel + 1
      if (this.lotterySel > 6) {
        this.lotterySel = 1
      }
      if (interval > 400 && this.lotterySel == target) {
        if (type == 1) {
          this.poplotteryvirdg = true;
        } else {
          this.poplotteryentdg = true;
        }
        return
      }
      setTimeout(() => {
        interval = interval + 5 * parseInt(1 + interval / 100)
        this.doLottery(interval, target, type);
      }, interval);
    },
    editAddr() {
      this.poplotteryentdg = false;
      this.popeditaddrdg = true;

      if (!this.hasAddr) {
        this.addrTitle = "填写地址";
      } else {
        this.addrTitle = "我的地址";
      }
    },
    saveAddr() {
      // check
      if (this.innamein == '') {
        alert("请输入姓名");
        return;
      }
      if (this.inmobiliein == '') {
        alert("请输入手机号");
        return;
      }
      const phonePattern = /^11[\d]{9}$|^12[\d]{9}$|^13[\d]{9}$|^14[5,7]{1}\d{8}$|^15[0-3,5-9]{1}\d{8}$|^16[\d]{9}$|^17\d{9}$|^18[\d]{9}$|^19[\d]{9}$/
      if (!phonePattern.test(this.inmobiliein)) {
        alert('请输入正确的手机号')
        return;
      }
      if (this.inaddrdetailin == '') {
        alert("请输入详细地址");
        return;
      }

      // request
      timeLessFillAddress(this.innamein, this.inmobiliein, this.inaddrdetailin).then(res => {
        if (res.code !== 0) {
          this.errObj.showErr(res.message)
        } else {
          this.popeditaddrdg = false;
          this.popaddrsucc = true;
          this.hasAddr = true;

          info.addr = {
            name: this.innamein,
            phone: this.inmobiliein,
            address: this.inaddrdetailin
          }
          info.isAddress = true
        }
      }).catch(err => {
        this.errObj.showErr(err)
        throw err
      })

    },
    sendCard() {
      this.$router.push("/illustration")
    },
  },
};
</script>
<style scoped>
.p4_bgpage {
  background-size: 100% auto;
  height: 100vh;
  min-height: 13.34rem;
}

.p4_dialoglotteryvirdg {
  margin-left: -0.24rem;
}

.p4_textvirrewardname {
  text-align: center;
}

.p4_textvirtip {
  line-height: 0.4rem;
  text-align: center;
}

.p4_dialoglotteryentd {
  margin-left: -0.24rem;
  position: fixed;
}

.p4_textentrewtname {
  text-align: center;
  left: 1.59rem;
}

.p4_inputaddrdetailin {
  height: 1.4rem;
}

.p4_inputaddrdetailin .van-cell {
  line-height: 0.44rem;
  height: 1.4rem;
}

.p4_inputaddrdetailin .van-field__control {
  height: 1.4rem;
}

.p4_inputnamein .van-field__control {
  width: 3.8rem;
}

.p4_inputnamein .van-cell {
  width: 3.8rem;
}

.p4_inputmobiliein .van-field__control {
  width: 3.8rem;
}

.p4_inputmobiliein .van-cell {
  width: 3.8rem;
}

.p4_textexvirtips {
  line-height: 0.4rem;
  text-align: center;
}

.p4_textexcontips span {
  color: #dc5b40;
}

.p4_dialogaddrsucc {
  margin-left: -0.24rem;
  position:fixed;
}

.p4_textaddrsuccconte {
  line-height: 0.4rem;
}

.p4_dialogexchangesuccvi {
  margin-left: -0.24rem;
}

.p4_dialogexchngeconfirm {
  margin-left: -0.24rem;
}

.p4_dialogeditaddrdg {
  margin-left: -0.24rem;
  position: fixed;
}

.p4_textsendcards {
  width: 100%;
  text-align: center;
  left: 0;
}
.p2_texthavecard {
  width: 100%;
  text-align: center;
  left: 0;
}
.p4_slotterymain {
  top: max(3.34rem, calc(3.34rem + (100vh - 13.34rem) / 2));
}
.p4_dientrew1 {
  width: 1.14rem;
  height: .98rem;
}
.p4_sliceentrew1 {
  width: 1.14rem;
  height: .98rem;
  left: .55rem;
  top: .6rem;
}
</style>
